import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';
import { OkrMyTeamFilters } from '../interfaces';

export const changeFilter = createAction<{
  key: keyof OkrMyTeamFilters;
  value: string | number | number[] | null;
}>(`${storeName}/changeFilter`);
